export function displayPrice(value: number | null) {
  if (value == null) return ''

  return value.toFixed(2).replace(/\.00$/, '')
}


export default displayPrice